import { mutationOptions } from '@tanstack/react-query';
import { paymentAPIClient } from '../paymentAPIClient';
import type {
  CapturePaypalOrderRequest,
  CreatePaymentIntentRequest,
  CreatePaypalOrderRequest,
  UpdatePaymentIntentRequest,
} from './types';

export const PAYMENT_MUTATIONS = {
  createPaymentIntent: () =>
    mutationOptions({
      mutationFn: (params: CreatePaymentIntentRequest) => paymentAPIClient.createPaymentIntent(params),
    }),
  updatePaymentIntent: () =>
    mutationOptions({
      mutationFn: (params: UpdatePaymentIntentRequest) => paymentAPIClient.updatePaymentIntent(params),
    }),
  createPaypalOrder: () =>
    mutationOptions({
      mutationFn: (params: CreatePaypalOrderRequest) => paymentAPIClient.createPaypalOrder(params),
    }),
  capturePaypalOrder: () =>
    mutationOptions({
      mutationFn: (params: CapturePaypalOrderRequest) => paymentAPIClient.capturePaypalOrder(params),
    }),
  recoverPaypalOrder: () =>
    mutationOptions({
      mutationFn: () => paymentAPIClient.recoverPaypalOrder(),
    }),
  acknowledgePaypalRecovery: () =>
    mutationOptions({
      mutationFn: () => paymentAPIClient.acknowledgePaypalRecovery(),
    }),
};
